<script lang="ts">
	import { graphQLErrors } from '../../stores';
	export let errorList = '';

	$: selectedErrors = errorList || $graphQLErrors;
</script>

<!-- TODO: stop using this component as it shows all error unrelated to current screen -->
{#if selectedErrors}
	<div class="wrap">
		{#each selectedErrors as err (err.message)}
			<p>{err.message}</p>
		{/each}
	</div>
	<slot />
{/if}

<style>
	.wrap {
		color: red;
	}
</style>
